import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ProductCard from "./ProductCard";
import { bestSellers, newArrivals, topOffers } from "../mock";
import { fetchProducts } from "../api";

const fallback = { best: bestSellers, new: newArrivals, offers: topOffers };

const tabs = [
  { key: "best", label: "Best Sellers" },
  { key: "new", label: "New Arrivals" },
  { key: "offers", label: "Top Offers" },
];

const FeaturedProducts = () => {
  const [active, setActive] = useState("best");
  const [data, setData] = useState({ best: [], new: [], offers: [] });
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [b, n, o] = await Promise.all([
          fetchProducts({ section: "best" }),
          fetchProducts({ section: "new" }),
          fetchProducts({ section: "offers" }),
        ]);
        if (mounted) setData({ best: b, new: n, offers: o });
      } catch {
        if (mounted) setData(fallback);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const current = { data: data[active]?.length ? data[active] : fallback[active] };

  return (
    <section>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-3.5">
        <h2 className="text-[18px] font-bold text-gray-800">Featured Products</h2>
        <div className="flex items-center gap-1.5">
          {tabs.map((t) => (
            <button
              key={t.key}
              onClick={() => setActive(t.key)}
              className={`text-[11.5px] font-semibold px-3 py-1 rounded-full transition-colors ${
                active === t.key
                  ? "bg-[#12a150] text-white"
                  : "text-gray-500 hover:text-[#0e7a3d] hover:bg-green-50"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
        <button
          onClick={() => navigate("/offers")}
          className="ml-auto flex items-center gap-1 text-[12.5px] font-semibold text-[#0e7a3d] hover:gap-2 transition-all"
        >
          View All <ArrowRight size={14} />
        </button>
      </div>
      <div
        key={active}
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6 gap-3 animate-hero-fade"
      >
        {current.data.map((p) => (
          <ProductCard key={p.id} p={p} />
        ))}
      </div>
    </section>
  );
};

export default FeaturedProducts;
